import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from "./Utils";
import TranslationPanel from "./TranslationPanel";
class SurveyContent extends Component {
  constructor(props) {
    super(props);

    const date = new Date();
    var minute = date.getMinutes();
    if (date.getMinutes() > 0 && date.getMinutes() < 10) {
      minute = "0" + date.getMinutes();
    }
    const showCurrentTime = date.getHours() + ":" + minute;
    this.state = {
      disableAddQuestionButton: false,
      showLoader: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      hideTextAreaPopup: false,
      fields: {
        scopeType: { name: "", id: "" },
        surveyGroupId: { name: "", id: "" },
      },
      scopeTypeValues: [],
      surveyGroupValue: [],
      title: "",
      scopeType: "",
      surveyGroupId: "",
      showOptionTextArea: false,
      typeName: "",
      surveyGroupName: "",
      values: [{ optionsCopy: [] }],
      surveyId: "",
      editable: true,
      editImageSrc: "./assets/images/edit.svg",
      selectedScopeGroup: "",
      selectedScopeType: "",
      user_editable: true,
      editedId: "-1",
      selectedDate: new Date(),
      num: 0,
      translationFor: null,
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.answerTypeValues = [];

    this.state.healthSystemId = localStorage.getItem("healthSystemId");
    this.state.hospitalId = localStorage.getItem("hospitalId");
    this.state.serviceLineId = localStorage.getItem("serviceLineId");
    var user = JSON.parse(localStorage.getItem("user_details"));

    this.state.user = user;

    if (
      !this.state.healthSystemId ||
      this.state.healthSystemId == "null" ||
      this.state.healthSystemId == "Select HealthSystem"
    ) {
      this.state.healthSystemId = user["healthSystemId"];
    }
    if (
      !this.state.hospitalId ||
      this.state.hospitalId == "null" ||
      this.state.hospitalId == "Select Hospital"
    ) {
      this.state.hospitalId = user.hospitalId;
    }
    if (
      !this.state.serviceLineId ||
      this.state.serviceLineId == "null" ||
      this.state.serviceLineId == "Select ServiceLine"
    ) {
      this.state.serviceLineId = user.serviceLineId;
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    var thisController = this;
    thisController.state.healthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.hospitalId = localStorage.getItem("hospitalId");
    thisController.state.serviceLineId = localStorage.getItem("serviceLineId");
    setTimeout(() => {
      thisController.fetchScopeType();
      thisController.fetchAnswerType();
      thisController.fetchSurveyWithId();
    }, 300);
  }
  deleteSurevyItem = (id) => {
    this.state.disableAddQuestionButton = false;
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-survey-item/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            deleteConstructorVariables.state.values = [];
            deleteConstructorVariables.setState(
              deleteConstructorVariables.state
            );
            deleteConstructorVariables.fetchSurveyItem();
          } else {
            // deleteApiViewController.notifyFailToLoad();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }

  };
  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Question deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchSurveyWithId() {
    var fetchController = this;
    $.ajax({
      url: "/my-jeeva-api/fetch-survey-with-id",

      method: "GET",
      data: {
        id: this.props.location.state.currentSurveyId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          fetchController.state.showLoader = true;
          fetchController.state.editable = false;
          fetchController.state.user_editable = false;
          fetchController.setState(fetchController.state);
          if (res.result != null) {
            fetchController.state.surveyId = res.result.id;
            fetchController.state.title = res.result.title;
            fetchController.state.scopeType = res.result.type;
            fetchController.state.surveyGroupId = res.result.surveyGroupId;
            fetchController.setState(fetchController.state);
            fetchController.state.surveyGroupName = res.result.surveyGroupName;
            fetchController.state.typeName = res.result.typeName;
            var scopeType = fetchController.state.scopeType;
            if (scopeType == "HEALTH_SYSTEM") {
              fetchController.fetchScopeGroups(scopeType);
            } else if (scopeType == "HOSPITAL") {
              fetchController.fetchScopeGroups(scopeType);
            } else if (scopeType == "SERVICE_LINE") {
              fetchController.fetchScopeGroups(scopeType);
            } else if (scopeType == "TREATMENT") {
              fetchController.fetchScopeGroups(scopeType);
            }
            var date = new Date(res.result.scheduledDate);
            fetchController.state.selectedDate = date;
          }
          fetchController.setState(fetchController.state);
          fetchController.fetchSurveyItem();
        }
      },
      // }
    });
  }
  fetchSurveyItem() {
    var fetchController = this;
    $.ajax({
      url: "/my-jeeva-api/fetch-survey-item",

      method: "GET",
      data: {
        userEmail: JSON.parse(localStorage.getItem("user_details"))["emailId"],
        surveyId: fetchController.state.surveyId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          fetchController.state.showLoader = true;
          fetchController.state.editable = false;
          fetchController.state.user_editable = false;
          fetchController.setState(fetchController.state);
          if (res.result != null) {
            fetchController.state.values = res.result;
            for (var i = 0; i < res.result.length; i++) {
              fetchController.state.values[i]["optionsCopy"] = [];
              fetchController.state.values[i].optionsCopy =
                res.result[i].options.split(",");
            }
            fetchController.setState(fetchController.state);
          }
        }
      },
    });
  }
  editUserValue = () => {
    this.state.editable = true;
    this.setState(this.state);
  };
  editValue = (e) => {
    e.preventDefault();
    this.state.user_editable = true;
    this.setState(this.state);
  };

  fetchScopeGroups = (scopeType) => {
    var thisController = this;
    thisController.state.loadView = false;
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
    thisController.state.surveyGroupValue = [];
    if (userRole == "HOSPITAL_ADMIN") {
      thisController.state.healthSystemId = JSON.parse(
        localStorage.getItem("user_details")
      )["healthSystemId"];
      thisController.state.hospitalId = JSON.parse(
        localStorage.getItem("user_details")
      )["hospitalId"];
      thisController.setState(thisController.state);
    } else if (
      window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
    ) {
      thisController.state.healthSystemId = JSON.parse(
        localStorage.getItem("user_details")
      )["healthSystemId"];
      thisController.state.hospitalId =
        thisController.props.location.state.hospitalId;
      thisController.state.serviceLineId =
        "00000000-0000-0000-0000-000000000000";
      thisController.setState(thisController.state);
    }
    var healthSystem = thisController.state.healthSystemId;
    var hospital = thisController.state.hospitalId;
    var serviceLine = thisController.state.serviceLineId;
    var scopeGroupInfo;

    if (serviceLine == "null" || serviceLine == null) {
      serviceLine = "00000000-0000-0000-0000-000000000000";
    }
    if (userRole == "PHYSICIAN" && scopeType == "TREATMENT") {
      var providerId = JSON.parse(localStorage.getItem("user_details"))[
        "userId"
      ];
      var hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: hospitalId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(procedure => !procedure.isDeactivated).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            for (var i = 0; i < scopeGroupInfo.length; i++) {
              if(scopeGroupInfo[i].createdBy != null && scopeGroupInfo[i].createdBy === thisController.userDetails["emailId"]){
                if (scopeGroupInfo[i].name == thisController.state.surveyGroupName) {
                  thisController.state.surveyGroupValue.unshift({
                    name: scopeGroupInfo[i].name,
                    value: scopeGroupInfo[i].id,
                  });
                } else {
                  thisController.state.surveyGroupValue.push({
                    name: scopeGroupInfo[i].name,
                    value: scopeGroupInfo[i].id,
                  });
                }
              }
             thisController.setState(thisController.state);
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else if (userRole == "SERVICELINE_ADMIN" && scopeType == "TREATMENT") {
      var healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      var hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
      var serviceLineId = JSON.parse(localStorage.getItem("user_details"))[
        "serviceLineId"
      ];
      $.ajax({
        url: "/my-jeeva-api/procedure",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          serviceLineId: serviceLineId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(procedure => !procedure.isDeactivated);
            for (var i = 0; i < scopeGroupInfo.length; i++) {
              if (scopeGroupInfo[i].name == thisController.state.surveyGroupName) {
                thisController.state.surveyGroupValue.unshift({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              } else {
                thisController.state.surveyGroupValue.push({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              }
              thisController.setState(thisController.state);
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-survey-group",
        method: "GET",
        data: {
          surveyScope: scopeType,
          healthSystemId: healthSystem,
          hospitalId: hospital,
          serviceLineId: serviceLine,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.loadView = true;
            scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(procedure => !procedure.isDeactivated);
            for (var i = 0; i < scopeGroupInfo.length; i++) {
              var userRole = JSON.parse(localStorage.getItem("user_details"))[
                "userRole"
              ];
              if (userRole == "SERVICELINE_ADMIN") {
                var serviceLineId = JSON.parse(
                  localStorage.getItem("user_details")
                )["serviceLineId"];
                if (scopeGroupInfo[i].id == serviceLineId) {
                  thisController.state.surveyGroupValue.push({
                    name: scopeGroupInfo[i].name,
                    value: scopeGroupInfo[i].id,
                  });
                  thisController.setState(thisController.state);
                }
              } else if(userRole == "PHYSICIAN"){
                var serviceLineId = JSON.parse(
                  localStorage.getItem("user_details")
                )["serviceLineId"];
                var userMailId = JSON.parse(
                  localStorage.getItem("user_details")
                )["emailId"];
                if (scopeGroupInfo[i].id == serviceLineId && userMailId == scopeGroupInfo[i].createdByEmail ) {
                  thisController.state.surveyGroupValue.push({
                    name: scopeGroupInfo[i].name,
                    value: scopeGroupInfo[i].id,
                  });
                  thisController.setState(thisController.state);
                }
              } else if (
                scopeGroupInfo[i].name == thisController.state.surveyGroupName
              ) {
                thisController.state.surveyGroupValue.unshift({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              } else {
                thisController.state.surveyGroupValue.push({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              }
            }

            if (thisController.state.surveyGroupId == "") {
              thisController.state.surveyGroupId = {
                name: scopeGroupInfo[0].name,
                value: scopeGroupInfo[0].id,
              };
            }
            thisController.setState(thisController.state);
          }
        },
      });
    }
  };
  notifyFailToLoad() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }
  fetchScopeType = () => {
    let thisController = this;
    thisController.state.loadView = false;
    thisController.state.scopeTypeValues = [];
    $.ajax({
      url: "/my-jeeva-api/scope-type",
      type: "GET",

      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        thisController.state.loadView = true;
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var scopeTypeInfo = res.result;
          var numberOfScopeType = scopeTypeInfo.length;

          for (var i = 0; i < numberOfScopeType; i++) {
            if (
              scopeTypeInfo[i]["name"] != "HEALTH_SYSTEM" &&
              scopeTypeInfo[i]["name"] != "HOSPITAL"
            ) {
              thisController.state.scopeTypeValues.push(scopeTypeInfo[i]);
            }
          }
          thisController.setState(thisController.state);
        } else {
          // thisController.notifyFailToLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  };

  fetchAnswerType = () => {
    var fetchDataContoller = this;
    $.ajax({
      url: "/my-jeeva-api/survey-answer-type",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          fetchDataContoller.state.showOptionTextArea = false;
          fetchDataContoller.setState(fetchDataContoller.state);
          var loadAnswerType = res.result;
          var numberOfloadAnswerType = loadAnswerType.length;
          fetchDataContoller.answerTypeValues = [];
          for (var i = 0; i < numberOfloadAnswerType; i++) {
            fetchDataContoller.answerTypeValues[i] = loadAnswerType[i];
          }
        }
      },
    });
  };

  saveSurveyInfoApi = (props, e) => {
    this.state.editedId = "-1";
    this.setState(this.state);
    var saveController = this;
    var currentDate = new Date();
    var curDate = currentDate.getDate();
    var curMonth = currentDate.getMonth();
    var curYear = currentDate.getFullYear();
    var date = new Date(document.getElementById("scheduledDate").value);
    var selDate = date.getDate();
    var selMonth = date.getMonth();
    var selYear = date.getFullYear();
    var title = document.getElementById("surveyTitle").value.trim();
    var titlePattern = new RegExp(/^([a-zA-Z0-9 /''()#.,-])*$/);
    var addSurveyData = {
      title: title,
      createdByEmail: JSON.parse(localStorage.getItem("user_details"))[
        "emailId"
      ],
      createdByName: JSON.parse(localStorage.getItem("user_details"))["name"],
      type: document.getElementById("typeId").value,
      surveyGroupId: document.getElementById("surveyGroupId").value,
      scheduledDate: date,
    };
    if (title == "" || date == "") {
      saveController.notifyEmptyFields();
    } else if (selYear < curYear) {
      saveController.notifyImproperDate();
    } else if (selYear == curYear && selMonth < curMonth) {
      saveController.notifyImproperDate();
    } else if (
      selYear == curYear &&
      selMonth == curMonth &&
      selDate < curDate
    ) {
      saveController.notifyImproperDate();
    } else {
      $.ajax({
        url: "/my-jeeva-api/add-survey",

        method: "POST",
        data: JSON.stringify(addSurveyData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },

        success: function (res) {
          if (res.success === true) {
            saveController.state.editable = true;
            saveController.notifySurveyAdded();
            saveController.fetchSurveyWithId();
            saveController.setState({ disabled: false });
          } else {
            saveController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Past dates can't be selected, Please select Today or Future
        date.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  saveSurveyItemInfoApi = (index, e) => {
    this.state.editedId = "-1";
    this.setState(this.state);
    var saveController = this;
    var question = document
      .getElementById("questionId" + index)
      .textContent.trim();
    var answerType = document.getElementById("answerTypeId" + index).value;
    var options = document.getElementById("optionId" + index).textContent.trim();
    var optionsarray = options.split(",");

    var qnPattern = new RegExp(/^([a-zA-Z0-9.,?#_/\s])*$/);

    var addSurveyItemData = {
      options: options,
      type: answerType,
      question: question,
      surveyId: saveController.state.surveyId,
      typeName: document.getElementById("answerTypeId" + index).options[
        document.getElementById("answerTypeId" + index).selectedIndex
      ].text,
    };

    if (question == "" || answerType == "Select Answer Type") {
      saveController.notifyEmptyFields();
    } else if (answerType == "MULTISELECT" && options == "") {
      saveController.notifyEmptyFields();
    } else if (answerType == "SELECT" && options == "") {
      saveController.notifyEmptyFields();
    } else if (
      answerType == "MULTISELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      saveController.notifyNotProperOptions();
    } else if (
      answerType == "SELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      saveController.notifyNotProperOptions();
    } else {
      $.ajax({
        url: "/my-jeeva-api/add-survey-item",

        method: "POST",
        data: JSON.stringify(addSurveyItemData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },

        success: function (res) {
          if (res.success === true) {
            saveController.state.disableAddQuestionButton = false;
            saveController.notifyQnAdded();
            saveController.state.showLoader = true;
            saveController.setState(saveController.state);
            saveController.fetchSurveyItem();
            saveController.setState({ disabled: false });
          } else {
            saveController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };

  notifyImproperQuestion() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Kindly avoid special characters.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyNotProperOptions() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please add more than one options
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperTitle() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid Title
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyQnAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Question added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySurveyAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;New survey created successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  handleChange = (e) => {
    document.getElementById("questionId").innerHTML = e.target.value;
    this.setState(this.state);
  };

  handleAddQuestionButtonClick() {
    this.state.disableAddQuestionButton = true;
    this.state.user_editable = false;
    this.state.showOptionTextArea = false;
    this.setState(this.state);
    this.setState((prevState) => ({
      values: [...prevState.values, { optionsCopy: [] }],
    }));
  }

  removeClick(i) {
    let values = [...this.state.values];
    values.splice(i, 1);
    this.setState({ values });
  }

  handleSubmit(event) {
    event.preventDefault();
  }
  onChange = (date) => {
    this.state.selectedDate = date;
    this.setState(this.state);
  };
  onChangeScopeType = (e) => {
    this.state.scopeType = e.target.value;
    // this.setState(this.state);
    var scopeType = e.target.value;
    this.fetchScopeGroups(scopeType);
    this.setState(this.state);
  };
  onChangeGroupValue = (e) => {
    this.state.surveyGroupName =
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
    this.state.surveyGroupId = e.target.value;
    this.setState(this.state);
  };

  makeCelledit(index) {
    this.markAsBeingEdited(this.state.values[index].id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    this.state.disableAddQuestionButton = true;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }
  updateSurveyItemApi = (index) => {
    this.state.editable = false;
    this.setState(this.state);
    var updateController = this;
    var question = document
      .getElementById("questionId" + index)
      .textContent.trim();
    var answerType = document.getElementById("answerTypeId" + index).value;
    var options = document.getElementById("optionId" + index).textContent.trim();
    var optionsarray = options.split(",");
    var qnPattern = new RegExp(/^([a-zA-Z0-9.,?#_/\s])*$/);
    var updatedData = {
      id: updateController.state.values[index].id,
      question: question,
      type: answerType,
      options: options,
      typeName: document.getElementById("answerTypeId" + index).options[
        document.getElementById("answerTypeId" + index).selectedIndex
      ].text,
    };
    if (question == "" || answerType == "Select Answer Type") {
      updateController.notifyEmptyFields();
    } else if (answerType == "MULTISELECT" && options == "") {
      updateController.notifyEmptyFields();
    } else if (answerType == "SELECT" && options == "") {
      updateController.notifyEmptyFields();
    } else if (
      answerType == "MULTISELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      updateController.notifyNotProperOptions();
    } else if (
      answerType == "SELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      updateController.notifyNotProperOptions();
    } else {
      $.ajax({
        url: "/my-jeeva-api/update-survey-item",

        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updateController.state.showLoader = true;
            updateController.state.editedId = "-1";
            updateController.state.editable = true;
            updateController.state.disableAddQuestionButton = false;
            updateController.setState(updateController.state);
            updateController.notifyUpdate();
            updateController.fetchSurveyWithId();
          } else {
            updateController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  updateSurveyApi = () => {
    var updateController = this;
    var title = updateController.state.title;
    var currentDate = new Date();
    var curDate = currentDate.getDate();
    var curMonth = currentDate.getMonth();
    var curYear = currentDate.getFullYear();
    var selectedDate = updateController.state.selectedDate;
    var date = new Date(updateController.state.selectedDate);
    var selDate = date.getDate();
    var selMonth = date.getMonth();
    var selYear = date.getFullYear();
    var titlePattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );
    var selectGroupValidation = document.getElementById("surveyGroupId").options[
      document.getElementById("surveyGroupId").selectedIndex
    ].text;
    updateController.setState(updateController.state);
    var updatedData = {
      id: updateController.props.location.state.currentSurveyId,
      title: title,
      createdByEmail: JSON.parse(localStorage.getItem("user_details"))[
        "emailId"
      ],
      createdByName: JSON.parse(localStorage.getItem("user_details"))["name"],
      type: updateController.state.scopeType,
      surveyGroupId: updateController.state.surveyGroupId,
      scheduledDate: date,
      typeName:
        document.getElementById("typeId").options[
          document.getElementById("typeId").selectedIndex
        ].text,
      surveyGroupName:
        document.getElementById("surveyGroupId").options[
          document.getElementById("surveyGroupId").selectedIndex
        ].text,
    };
    if (
      title == "" ||
      date == "" ||
      selectedDate == "" ||
      selectedDate == null
    ) {
      updateController.notifyEmptyFields();
    } else if (!titlePattern.test(title)) {
      updateController.notifyImproperTitle();
    } else if (selYear < curYear) {
      updateController.notifyImproperDate();
    } else if (selYear == curYear && selMonth < curMonth) {
      updateController.notifyImproperDate();
    } else if (
      selYear == curYear &&
      selMonth == curMonth &&
      selDate < curDate
    ) {
      updateController.notifyImproperDate();
    } else if (selectGroupValidation == "Select Scope Group") {
      updateController.notifyEmptyScopeGroup();
    } else {
      $.ajax({
        url: "/my-jeeva-api/update-survey",

        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updateController.state.showLoader = true;
            updateController.state.editedId = "-1";
            updateController.state.user_editable = true;
            updateController.state.disabled = false;
            updateController.notifySurveyUpdate();
            updateController.fetchSurveyWithId();
          } else {
            updateController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };

  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyEmptyScopeGroup() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please select the Scope Group
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySurveyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Survey updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Survey Item updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  onHandleChangeAnswerType = (index, e) => {
    var answerType = document.getElementById("answerTypeId" + index).value;
    this.state.values[index].type = answerType;
    //  answerType = e.target.value;
    if (answerType == "SELECT" || answerType == "MULTISELECT") {
      this.state.showOptionTextArea = true;
    } else {
      this.state.showOptionTextArea = false;
    }
    this.setState(this.state);
  };
  onChangeTitle = (e) => {
    this.state.title = e.target.value;
    this.setState(this.state);
  };
  goBackFromSubTab = () => {
    var pageNum = this.props.location.state.pageNum;
    this.props.history.push({
      pathname: "/projectmgmt/survey",
    });
  };

  incNum = () => {
    var thisController = this;
    if (thisController.state.num < 10) {
      thisController.state.num = Number(thisController.state.num) + 1;
    }
    thisController.setState(thisController.state);
  };
  decNum = () => {
    var thisController = this;
    if (thisController.state.num > 0) {
      thisController.state.num = Number(thisController.state.num) - 1;
    }
    thisController.setState(thisController.state);
  };

  openDeletePopUp = (id) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: "Are you sure you want to delete this question ? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteSurevyItem(id),
        },
        {
          label: "No",
        },
      ],
    });
  };
  handleDeleteQuestionButtonClick(id) {
    this.state.disableAddQuestionButton = false;
    if (id) {
      this.openDeletePopUp(id);
    } else {
      this.state.values = [];
      this.setState(this.state);
      this.fetchSurveyWithId();
    }
  }

  render() {
    return (
      <div id="scheduleSurveyTab">
        {this.state.translationFor && (
          <TranslationPanel
            entityType={this.state.translationFor.entityType}
            entityId={this.state.translationFor.entityId}
            title={this.state.translationFor.title}
            fields={this.state.translationFor.fields}
            sourceFields={this.state.translationFor.sourceFields}
            procedureId={typeof this.state.surveyGroupId === 'object' ? this.state.surveyGroupId.id : this.state.surveyGroupId}
            onClose={() => {
              this.setState({ translationFor: null });
              if (this.state.translationFor.entityType === "survey") {
                this.fetchSurveyWithId();
              } else if (this.state.translationFor.entityType === "surveyItem") {
                this.fetchSurveyItem();
              }
            }}
          />
        )}
        <div
          style={{
            background: "#F9F9FB",
            display: this.state.showLoader ? "block" : "none",
          }}
        >
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />

          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          {/* IonIcons */}
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Select2 */}
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />

          <div className="content-header">
            <div>
              <link rel="stylesheet" href="assets/css/ReactToastify.css" />
              <ToastContainer className="Toast-at-center" />

              <div className="row">
                <div className="col-sm-4" Align="left">
                  <img
                    src="assets/images/arrow.svg"
                    style={{ paddingRight: "30%", cursor: "pointer" }}
                    onClick={this.goBackFromSubTab}
                  />
                </div>

                <div
                  className="col-sm-4"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h6
                    className="nav-item"
                    style={{
                      color: "#282a65",
                      marginLeft: "1vw",
                    }}
                  >
                    New Survey
                  </h6>
                </div>
                <div className="col-sm-4"></div>
              </div>
              <div className="card-body p-0 mb-25">
                <div className="tab-content col-12 p-0">
                  <div
                    className="card card-primary mt-3"
                    style={{ height: "80%" }}
                  >
                    <div
                      style={{ marginLeft: "1vw", marginTop: "2vw" }}
                      className="raiseTicketLable"
                    >
                      <div className="row">
                        <div className="col-sm-6"></div>
                        <div className="col-sm-6" Align="right">
                          <button
                            style={{
                              backgroundColor: "#ffffff",
                              border: "none",
                              marginTop: "-9px",
                              marginLeft: "-6px",
                            }}
                            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy")}
                            onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy") ? null
                              :
                              this.state.editable
                                ? this.updateSurveyApi
                                : this.editUserValue
                            }
                          >
                            <img
                              className="img-responsive"
                              style={{
                                marginTop: "6px",
                                backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy")
                                            ? "#282a6596"
                                            : "#282a65",
                                borderRadius: "5px",
                                padding: "1px",
                              }}
                              src={
                                this.state.editable
                                  ? this.saveImageSrc
                                  : this.editImageSrc
                              }
                            />
                          </button>
                          {this.state.surveyId &&
                            this.state.surveyId !== "" && (
                              <button
                                title="Edit translations"
                                style={{
                                  backgroundColor: "#fff",
                                  border: "none",
                                  marginLeft: "6px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() =>
                                  this.setState({
                                    translationFor: {
                                      entityType: "survey",
                                      entityId: this.state.surveyId,
                                      title: this.state.title,
                                      fields: [
                                        {
                                          name: "title",
                                          label: "Title",
                                          rows: 1,
                                        },
                                      ],
                                      sourceFields: {
                                        title: this.state.title,
                                      },
                                    },
                                  })
                                }
                              >
                                <img className="img-responsive" src="./assets/images/translate_white_24dp.svg" alt="translate" style={{ marginTop: "6px", backgroundColor: "#282a65", borderRadius: "5px", padding: "1px", width: "24px", height: "24px" }} />
                              </button>
                            )}
                        </div>
                      </div>
                      <div className="row" Align="left">
                        <div className="col-sm-6">
                          <div className="row">
                            <div className="col-sm-4">
                              <label>Title</label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-7">
                              <textarea
                                className="col-sm-8"
                                type="text"
                                value={this.state.title}
                                onChange={(e) => this.onChangeTitle(e)}
                                name="name"
                                id="surveyTitle"
                                placeholder="Enter Title"
                                disabled={!this.state.editable}
                                style={{
                                  border: "none",
                                  height: "4vh",
                                  borderBottom: !this.state.editable
                                    ? "1px solid #ffffff"
                                    : "1px solid #b2b2b2",
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6">
                          <div className="row">
                            <div className="col-sm-4">
                              <label> Launch Date</label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-7">
                              <DatePicker
                                disabled={!this.state.editable}
                                style={{
                                  width: "10px",
                                  marginLeft: "70%",
                                  cursor: "pointer",
                                  paddingTop: "3rem",
                                }}
                                autoOk={true}
                                id="scheduledDate"
                                placeholder="Launch Date"
                                selected={this.state.selectedDate}
                                onChange={this.onChange}
                                dateFormat="MM/dd/yyyy"
                              ></DatePicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br />

                      <div className="row" Align="left">
                        <div className="col-sm-6">
                          <div className="row">
                            <div className="col-sm-4">
                              <label>Scope Type</label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-7">
                              <div
                                className="textarea"
                                style={{
                                  display: this.state.editable
                                    ? "none"
                                    : "block",
                                  background: "white",
                                  height: "2.7em",
                                  resize: "none",
                                  paddingLeft: "2px",
                                  paddingTop: "6px",
                                  width: "98%",
                                }}
                              //id="typeId"
                              >
                                {this.state.typeName}
                              </div>
                              <select
                                className="col-sm-8"
                                disabled={!this.state.editable}
                                name="typeId"
                                id="typeId"
                                value={this.state.scopeType}
                                onChange={(e) => this.onChangeScopeType(e)}
                                style={{
                                  display: this.state.editable
                                    ? "block"
                                    : "none",
                                  padding: "0.375rem 0.75rem",
                                  background: "white",
                                  borderBlockColor: "rgb(178, 178, 178)",
                                  borderRadius: "5px",
                                  height: "32px",
                                }}
                              >
                                {this.state.scopeTypeValues.map((typeId) => (
                                  <option value={typeId.name}>
                                    {typeId.code}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="row">
                            <div className="col-sm-4">
                              <label>Scope Group</label>
                            </div>
                            <div className="col-sm-1">:</div>
                            <div className="col-sm-7">
                              <div
                                className="textarea"
                                style={{
                                  display: this.state.editable
                                    ? "none"
                                    : "block",
                                  background: "white",
                                  height: "2.7em",
                                  resize: "none",
                                  paddingLeft: "2px",
                                  paddingTop: "6px",
                                  width: "auto",
                                }}
                              >
                                {this.state.surveyGroupName}
                              </div>
                              <select
                                className="col-sm-8"
                                disabled={!this.state.editable}
                                name="surveyGroupId"
                                id="surveyGroupId"
                                value={this.state.surveyGroupId}
                                onChange={(e) => this.onChangeGroupValue(e)}
                                style={{
                                  display: this.state.editable
                                    ? "block"
                                    : "none",
                                  padding: "0.375rem 0.75rem",
                                  background: "white",
                                  borderBlockColor: "rgb(178, 178, 178)",
                                  borderRadius: "5px",
                                  height: "32px",
                                }}
                              >
                                {this.state.surveyGroupValue.map(
                                  (surveyGroupKey) => (
                                    <option value={surveyGroupKey.value}>
                                      {surveyGroupKey.name}
                                    </option>
                                  )
                                )}
                                <option hidden value="Select Scope Group">
                                  Select Scope Group
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div
                      style={{
                        overflowY: "scroll",
                        height: "46vh",
                        overflowX: "hidden",
                      }}
                    >
                      <div>
                        {this.state.values.map((el, i) => (
                          <div key={i}>
                            <div>
                              <div>
                                <div
                                  className="row"
                                  style={{
                                    marginTop: "4vw",
                                    marginLeft: "1vw",
                                  }}
                                >
                                  <div className="col-sm-9" Align="left">
                                    <div className="col-sm-2">
                                      <label> Question:</label>
                                    </div>
                                    <div
                                      className="textarea"
                                      disabled={!this.state.user_editable}
                                      style={{
                                        textAlign: "left",
                                        background: "white",
                                        height: "4.7em",
                                        resize: "none",
                                        paddingLeft: "2px",
                                        paddingTop: "6px",
                                        width: "90%",
                                        fontSize: "1.5em",
                                        border:
                                          this.state.values[i].id ==
                                            undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "1px solid #D2D4DC"
                                            : "none",
                                        borderRadius:
                                          this.state.values[i].id ==
                                            undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "6px"
                                            : "none",
                                      }}
                                      id={"questionId" + [i]}
                                      contentEditable={
                                        !(this.state.values[i].id == undefined
                                          ? false
                                          : this.state.values[i].id !=
                                          this.state.editedId)
                                          ? "plaintext-only"
                                          : false
                                      }
                                    >
                                      {this.state.values[i].question}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="row"
                                  style={{
                                    marginTop: "2vw",
                                    marginLeft: "1vw",
                                  }}
                                >
                                  <div className="col-sm-2" Align="left">
                                    <label>Answer Type:</label>
                                  </div>
                                  <div className="col-sm-8" Align="left">
                                    <label
                                      style={{
                                        marginLeft: "1vw",
                                        display:
                                          this.state.showOptionTextArea ||
                                            this.state.values[i].type ==
                                            "SELECT" ||
                                            this.state.values[i].type ==
                                            "MULTISELECT"
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      Options:
                                    </label>
                                  </div>
                                  <div className="col-sm-2"></div>
                                </div>
                                <div
                                  className="row"
                                  style={{ marginLeft: "1vw" }}
                                >
                                  <div className="col-sm-2">
                                    <select
                                      id={"answerTypeId" + [i]}
                                      className="answerType"
                                      onChange={(e) =>
                                        this.onHandleChangeAnswerType(i, e)
                                      }
                                      value={this.state.values[i].type}
                                      placeholder="Select Answer Type"
                                      disabled={
                                        this.state.values[i].id == undefined
                                          ? false
                                          : this.state.values[i].id !=
                                          this.state.editedId
                                      }
                                      style={{
                                        height: "30px",
                                        borderRadius: "4px",
                                        backgroundColor: "#F9F9FB",
                                        width: "9vw",
                                      }}
                                    >
                                      {this.answerTypeValues.map(
                                        (answerTypeKey) => (
                                          <option
                                            key={answerTypeKey}
                                            value={answerTypeKey["name"]}
                                          >
                                            {answerTypeKey["code"]}
                                          </option>
                                        )
                                      )}
                                      <option hidden value="Select Answer Type">
                                        Select Answer Type
                                      </option>
                                    </select>
                                  </div>
                                  <div className="col-sm-8">
                                    <div
                                      className="textarea"
                                      disabled={!this.state.user_editable}
                                      style={{
                                        display:
                                          (this.state.values[i].id ==
                                            undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId) &&
                                            (this.state.values[i].type ==
                                              "MULTISELECT" ||
                                              this.state.values[i].type ==
                                              "SELECT")
                                            ? "block"
                                            : "none",
                                        textAlign: "left",
                                        background: "white",
                                        height: "2.7em",
                                        resize: "none",
                                        paddingLeft: "2px",
                                        paddingTop: "6px",
                                        width: "75%",
                                        border:
                                          this.state.values[i].id ==
                                            undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "1px solid #D2D4DC"
                                            : "none",
                                        borderRadius:
                                          this.state.values[i].id ==
                                            undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "6px"
                                            : "none",
                                      }}
                                      id={"optionId" + [i]}
                                      contentEditable={
                                        !(this.state.values[i].id == undefined
                                          ? false
                                          : this.state.values[i].id !=
                                          this.state.editedId)
                                          ? "plaintext-only"
                                          : false
                                      }
                                    >
                                      {this.state.values[i].options}
                                    </div>
                                    <div
                                      style={{
                                        display:
                                          (this.state.values[i].id ==
                                            undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId) &&
                                            this.state.values[i].type == "INTEGER"
                                            ? "inline-flex"
                                            : "none",
                                      }}
                                    >
                                      <div className="col-sm-2">
                                        <button
                                          className="btn btn-outline-primary"
                                          style={{
                                            border: "1px #007bff solid",
                                          }}
                                          type="button"
                                          onClick={this.decNum}
                                        >
                                          -
                                        </button>
                                      </div>
                                      <div className="col-sm-2">
                                        <input
                                          type="text"
                                          className="form-control"
                                          style={{
                                            borderBottom: "none",
                                            textAlign: "center",
                                          }}
                                          value={this.state.num}
                                          disabled
                                        />
                                      </div>
                                      <div className="col-sm-2">
                                        <button
                                          className="btn btn-outline-primary"
                                          style={{
                                            border: "1px #007bff solid",
                                          }}
                                          type="button"
                                          onClick={this.incNum}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display:
                                          this.state.values[i].id ==
                                            undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "none"
                                            : "block",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display:
                                            this.state.values[i].type ==
                                              "MULTISELECT"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {this.state.values[i].optionsCopy.map(
                                          (optionItem) => (
                                            <span>
                                              <input
                                                type="checkbox"
                                                id="checkboxid"
                                              />
                                              &nbsp;
                                              {optionItem}
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                          )
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display:
                                            this.state.values[i].type ==
                                              "SELECT"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {this.state.values[i].optionsCopy.map(
                                          (optionItem) => (
                                            <span>
                                              <input
                                                type="radio"
                                                name="selectCheck"
                                              />
                                              &nbsp;
                                              {optionItem}
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                          )
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display:
                                            this.state.values[i].type ==
                                              "BOOLEAN"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <span>
                                          <input
                                            type="radio"
                                            name="booleanCheck"
                                          />
                                          &nbsp; Yes
                                        </span>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <span>
                                          <input
                                            type="radio"
                                            name="booleanCheck"
                                          />
                                          &nbsp; No
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          display:
                                            this.state.values[i].type ==
                                              "INTEGER"
                                              ? "inline-flex"
                                              : "none",
                                        }}
                                      >
                                        <div className="col-sm-2">
                                          <button
                                            className="btn btn-outline-primary"
                                            style={{
                                              border: "1px #007bff solid",
                                            }}
                                            type="button"
                                            disabled
                                          >
                                            -
                                          </button>
                                        </div>
                                        <div className="col-sm-2">
                                          <input
                                            type="text"
                                            className="form-control"
                                            style={{
                                              borderBottom: "none",
                                              textAlign: "center",
                                            }}
                                            value={this.state.num}
                                            disabled
                                          />
                                        </div>
                                        <div className="col-sm-2">
                                          <button
                                            className="btn btn-outline-primary"
                                            style={{
                                              border: "1px #007bff solid",
                                            }}
                                            type="button"
                                            disabled
                                          >
                                            +
                                          </button>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display:
                                            this.state.values[i].type ==
                                              "DESCRIPTIVE"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {this.state.values[i].optionsCopy.map(
                                          (optionItem) => (
                                            <div
                                              className="textarea"
                                              style={{
                                                border: "1px solid #D2D4DC",
                                                borderRadius: "2px",
                                                textAlign: "left",
                                                background: "white",
                                                height: "2.7em",
                                                resize: "none",
                                                paddingLeft: "2px",
                                                paddingTop: "6px",
                                                width: "75%",
                                              }}
                                              contentEditable={false}
                                              placeholder="Similar text area made available to audience"
                                            >
                                              {optionItem}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-sm-3" style={{ marginLeft: "60vw" }}>
                                      <button
                                        style={{
                                          backgroundColor: "#ffffff",
                                          border: "none",
                                          marginTop: "-9px",
                                          marginLeft: "-6px",
                                        }}
                                      >
                                        <img
                                          className="img-responsive"
                                          title={
                                            this.state.values[i].id ==
                                              undefined ||
                                              this.state.values[i].id ==
                                              this.state.editedId
                                              ? "Save"
                                              : "Edit"
                                          }
                                          disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy")}
                                          style={{
                                            marginTop: "6px",
                                            backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy")
                                              ? "#282a6596"
                                              : "#282a65",
                                            borderRadius: "5px",
                                            padding: "1px",
                                          }}
                                          src={
                                            this.state.values[i].id == undefined
                                              ? this.saveImageSrc
                                              : this.state.values[i].id !=
                                                this.state.editedId
                                                ? this.editImageSrc
                                                : this.saveImageSrc
                                          }
                                          onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy") ? null : (e) => {
                                              this.state.values[i].id == undefined
                                                ? this.saveSurveyItemInfoApi(i)
                                                : this.state.values[i].id ==
                                                  this.state.editedId
                                                  ? this.updateSurveyItemApi(i)
                                                  : this.makeCelledit(i);
                                            }}
                                        />
                                      </button>
                                      {this.state.values[i].id &&
                                        this.state.values[i].id !== "" && (
                                          <button
                                            title="Edit translations"
                                            style={{
                                              backgroundColor: "#fff",
                                              border: "none",
                                              marginLeft: "6px",
                                              cursor: "pointer",
                                              fontSize: "16px",
                                            }}
                                            onClick={() => {
                                              const fields = [
                                                {
                                                  name: "question",
                                                  label: "Question",
                                                  rows: 4,
                                                },
                                              ];
                                              const sourceFields = {
                                                question:
                                                  this.state.values[i].question,
                                              };
                                              // Only include options field for SELECT and MULTISELECT types
                                              if (this.state.values[i].type === "SELECT" || this.state.values[i].type === "MULTISELECT") {
                                                fields.push({
                                                  name: "options",
                                                  label: "Options (JSON)",
                                                  rows: 4,
                                                });
                                                sourceFields.options =
                                                  this.state.values[i].options;
                                              }
                                              this.setState({
                                                translationFor: {
                                                  entityType: "surveyItem",
                                                  entityId: this.state.values[i].id,
                                                  title:
                                                    this.state.values[i].question ||
                                                    "Survey item",
                                                  fields: fields,
                                                  sourceFields: sourceFields,
                                                },
                                              })
                                            }}
                                          >
                                            <img className="img-responsive" src="./assets/images/translate_white_24dp.svg" alt="translate" style={{ marginTop: "6px", backgroundColor: "#282a65", borderRadius: "5px", padding: "1px", width: "24px", height: "24px" }} />
                                          </button>
                                        )}
                                      <button
                                        style={{
                                          backgroundColor: "#ffffff",
                                          border: "none",
                                          marginTop: "-9px",
                                          marginLeft: "-6px",
                                        }}
                                        title="Delete"
                                      >
                                        <img
                                          className="img-responsive"
                                          src={
                                            "./assets/images/baseline_delete_white_24dp.png"
                                          }
                                          disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy")}
                                          style={{
                                            marginTop: "6px",
                                            backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy")
                                              ? "#282a6596"
                                              : "#282a65",
                                            borderRadius: "5px",
                                            padding: "1px",
                                          }}
                                          onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy") ? null : () =>
                                            this.handleDeleteQuestionButtonClick(
                                              this.state.values[i].id
                                            )
                                          }
                                        />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-2"></div>
                                  <div className="col-sm-8">
                                    <label
                                      style={{
                                        marginLeft: "1vw",
                                        display:
                                          (this.state.showOptionTextArea ||
                                            this.state.values[i].type ==
                                            "SELECT" ||
                                            this.state.values[i].type ==
                                            "MULTISELECT") &&
                                            (this.state.values[i].id ==
                                              undefined ||
                                              this.state.values[i].id ==
                                              this.state.editedId)
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      Add Comma separated options (Ex:
                                      option1,option2 etc)
                                    </label>
                                  </div>
                                  <div className="col-sm-2"></div>
                                </div>
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                      </div>

                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={this.state.disableAddQuestionButton}
                        style={{
                          width: "150px",
                          fontSize: "14px",
                          marginLeft: "3vw",
                          marginTop: "3vw",
                          marginBottom: "2vw",
                          // backgroundColor: this.state.disableAddQuestionButton ? "#666e77" : "#282a65",
                          backgroundColor: this.state.disableAddQuestionButton
                            ? "#666e77"
                            : (this.userDetails["userRole"] === "PHYSICIAN" &&
                              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy"))
                              ? "#282a6596"
                              : "#282a65",
                          borderColor: this.state.disableAddQuestionButton ? "#666e77" : "#282a65"
                        }}
                        onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("surveyCreatedBy") ? null :
                          this.handleAddQuestionButtonClick.bind(this)}
                      >
                        Add Question
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyContent;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/SurveyContent.js